import React, { forwardRef, memo } from 'react';
import isEqual from 'lodash/isEqual';
import useEnlog from 'app/hook/common/useEnlog';
import classNames from 'classnames/bind';
import styles from './SelectBox.module.scss';

const cx = classNames.bind(styles);

const SelectBox = forwardRef((props, ref) => {
	const {
		classArray = [],
		title = '',
		name,
		id,
		data,
		style = null,
		value = undefined,
		theme = 'uiselectbox_drop',
		onClick = undefined,
		onChange = undefined,
		onBlur = undefined,
		validation = false,
		validationText = '',
		validationTextAuto = '',
		disabled = false,
		size = '50',
		required = false,
		labelStyle = undefined,
		removeArrow = false,
	} = props;

	const { propsDataset } = useEnlog();
	const dataSet = propsDataset(props);

	const options = data.map((item) => (
		<option
			key={item.key}
			value={item.value}
		>
			{item.name}
		</option>
	));

	return (
		<div
			className={cx({ alert: validation }, classArray, `uiselect_size_h${size}`)}
			style={style}
		>
			{title !== '' && (
				<label
					htmlFor={id}
					className={cx('lab_select', { required })}
					style={labelStyle}
				>
					{title}
				</label>
			)}
			<select
				name={name}
				id={id}
				className={cx(theme, { alert: validation }, { placeholder: !value }, { removeArrow })}
				value={value}
				onClick={onClick}
				onChange={onChange}
				ref={ref}
				disabled={disabled}
				onBlur={onBlur}
				{...dataSet}
			>
				{options}
			</select>
			{validation && (
				<>
					{validationText && (
						<p
							className={cx('noti_txt')}
							data-testid="validateText"
						>
							{validationText}
						</p>
					)}
					{validationTextAuto && (
						<p
							className={cx('noti_txt')}
							data-testid="validateText"
						>
							{title}
							{validationTextAuto} 선택해주세요.
						</p>
					)}
				</>
			)}
		</div>
	);
});

export default memo(SelectBox, isEqual);
